// extracted by mini-css-extract-plugin
export var bold = "_r5-0";